import { SafeLink } from "@/components/ui/SafeLink";
import { Button } from "@/components/ui/button";
import { SlideFromLeft, SlideFromRight } from "@/components/ui/animations";

export default function Tiles() {
    return (        
        <div className="flex flex-col w-full bg-gradient-to-b from-gray-50 to-gray-100 relative overflow-hidden">
            {/* Background decorative elements */}
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-0 left-1/4 w-32 h-32 bg-red-500/3 rounded-full blur-3xl"></div>
                <div className="absolute bottom-1/3 right-1/4 w-48 h-48 bg-gray-900/2 rounded-full blur-3xl"></div>
            </div>

            {/* Heat Pumps & Air Conditioning */}
            <SlideFromLeft Component={                
                <div id="heat-pumps" className=" lg:px-6 xl:px-12 py-14 relative z-10">                    
                    <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10 lg:gap-12 justify-center">                        
                        <div className="relative group flex-shrink-0 px-4 md:px-6 lg:px-0 transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">                        
                            <img
                                loading="eager"
                                className="md:w-full lg:max-w-xl xl:max-w-2xl w-full h-full  lg:h-72 xl:h-80 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                src={`${process.env.REACT_APP_BLOB_URL}/www/img/products/heating-cooling-mitsubishi-lifestyle.jpg`}
                                alt="Stylish living room with wall-mounted air conditioning unit"
                            />
                            {/* Dark overlay for hover effect */}
                            <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            {/* Animated shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                        </div>
                        <div className="flex flex-col gap-10 md:gap-8 lg:px-0 px-4 text-center lg:text-left">                            
                            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 max-w-lg sm:mx-auto md:mx-auto lg:mx-0 lg:max-w-xl leading-tight">
                                <span className="hero-text-gradient-red">Heat Pumps & </span> Air Conditioning
                            </h2>
                            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                                Upgrade any space with efficient, sustainable heat pumps and air conditioning systems from trusted brands. Engineered for all seasons, our solutions ensure year-round comfort, energy savings, and reliable performance for offices, accommodation, retail, and more.
                            </p>                           
                        </div>
                    </div>
                </div>
            } />

            {/* Subtle section separator */}
            <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300/50 to-transparent mx-auto"></div>

            {/* Panel Heaters */}
            <SlideFromRight Component={                
                <div id="panel-heaters" className="lg:px-6 xl:px-12 py-14 relative z-10">                    
                    <div className="flex flex-col lg:flex-row-reverse items-center gap-8 md:gap-10 lg:gap-12 justify-center">                        
                        <div className="relative group flex-shrink-0 px-4 md:px-6 lg:px-0 transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">                        
                            <img
                                loading="eager"
                                className="md:w-full lg:max-w-xl xl:max-w-2xl w-full h-full lg:h-72 xl:h-80 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                src={`${process.env.REACT_APP_BLOB_URL}/www/img/products/heating-cooling-noirot-lifestyle.jpg`}
                                alt="Wall-mounted panel heater in a bright, modern living room"
                            />
                            {/* Dark overlay for hover effect */}
                            <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            {/* Animated shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                        </div>
                        <div className="flex flex-col gap-10 md:gap-4 lg:px-0 px-4 text-center lg:text-left">                            
                            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 max-w-lg sm:mx-auto md:mx-auto lg:mx-0 leading-tight">
                                Panel <span className="hero-text-gradient-red"> Heaters  </span>
                                
                            </h2>
                            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                                Deliver targeted, space-saving warmth exactly where it’s needed. Our panel heaters are perfect for workshops, lobbies, bedrooms, and offices—blending reliable heating with a discreet footprint. 
                            </p>                            
                        </div>
                    </div>
                </div>
            } />

            {/* Subtle section separator */}
            <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300/50 to-transparent mx-auto"></div>

            {/* Indoor Fireplaces */}
            <SlideFromLeft Component={                
                <div id="indoor-fireplaces" className="lg:px-6 xl:px-12 py-14 relative z-10">                    
                    <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10 lg:gap-12 justify-center">                        
                        <div className="relative group flex-shrink-0 px-4 md:px-6 lg:px-0 transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">                        
                            <img
                                loading="eager"
                                className="md:w-full lg:max-w-xl xl:max-w-2xl w-full h-full lg:h-72 xl:h-80 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                src={`${process.env.REACT_APP_BLOB_URL}/www/img/products/heating-cooling-rinnai-lifestyle.jpg`}
                                alt="Elegant living room with built-in fireplace and minimalist styling"
                            />
                            {/* Dark overlay for hover effect */}
                            <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            {/* Animated shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                        </div>
                        <div className="flex flex-col gap-10 md:gap-4 lg:px-0 px-4 text-center lg:text-left">                            
                            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 max-w-lg sm:mx-auto md:mx-auto lg:mx-0 leading-tight">
                                <span className="hero-text-gradient-red">Indoor </span> Fireplaces
                            </h2>
                            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                                Add both ambiance and zoned comfort to your interiors. Our fireplaces are designed to impress, providing style and practical heating for lounges, suites, and shared spaces—perfect for hospitality, aged care, or high-end residential projects.
                            </p>                            
                        </div>
                    </div>
                </div>
            } />

             {/* Subtle section separator */}
            <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300/50 to-transparent mx-auto"></div>

            {/* Outdoor Heating Solutions */}
            <SlideFromRight Component={                
                <div id="outdoor-heating-solutions" className="lg:px-6 xl:px-12 py-14 relative z-10">                    
                    <div className="flex flex-col lg:flex-row-reverse items-center gap-8 md:gap-10 lg:gap-12 justify-center">                        
                        <div className="relative group flex-shrink-0 px-4 md:px-6 lg:px-0 transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">                            
                            <img
                                loading="eager"
                                className="md:w-full lg:max-w-xl xl:max-w-2xl w-full h-full lg:h-72 xl:h-80 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                src={`${process.env.REACT_APP_BLOB_URL}/www/img/products/heating-cooling-masport-lifestyle.jpg`}
                                alt="Outdoor lounge with central fireplace and mountain views"
                            />
                            {/* Dark overlay for hover effect */}
                            <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            {/* Animated shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                        </div>
                        <div className="flex flex-col gap-10 md:gap-4 lg:px-0 px-4 text-center lg:text-left">                            
                            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 max-w-lg sm:mx-auto md:mx-auto lg:mx-0 leading-tight">
                                <span className="hero-text-gradient-red">Outdoor Heating  </span> Solutions
                            </h2>

                            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                                Keep alfresco areas busy all year round. Our outdoor heaters and fireplaces bring comfort and style to patios, terraces, bars, and restaurant decks—extending the season and maximising your business potential.    
                            </p>                            
                        </div>
                    </div>
                </div>
            } />
            

        </div>
    )
}